<template>
    <div class="big_box">
        <div class="img_39">
            <div class="copy" @click="copy('cs@firewick.net')"></div>
        </div>
    </div>
</template>

<script>
module.exports = {
    data() {
        return {}
    },
    methods:{
        copy(text) {
            var input1 = document.querySelector("#input_copy")
            input1.value = text;
            input1.select();
            document.execCommand("Copy");
            this.$top_box.show_box('复制成功')
            input1.blur();
        },
    },
}
</script>

<style scoped>

.big_box.big_box.big_box{
    top: 0.52rem;
    height: 85%;
}
.copy{
    position: absolute;
    left:3.7rem;
    top:22.6rem;
    width:2rem;
    height:0.3rem;
    cursor:pointer;
}
</style>